import { plural } from '@cian/utils';
import * as React from 'react';

import { TAreaPartForDesktopSchema } from '../../../../types/results';
import { AreaLink } from '../AreaLink';

export interface IMoreAreasPartsLinkProps {
  areaParts: TAreaPartForDesktopSchema[];
  numberOfPartsToShow: number;
  href: string;
  handleClick?: VoidFunction;
}

export const MoreAreasPartsLink: React.FC<IMoreAreasPartsLinkProps> = props => {
  const { areaParts, handleClick, numberOfPartsToShow, href } = props;
  const numberOfAreaParts = areaParts && areaParts.length;

  if (!numberOfAreaParts) {
    return null;
  }

  const hasMoreThanMaxNumberOfAreas = numberOfAreaParts > numberOfPartsToShow;

  if (!hasMoreThanMaxNumberOfAreas) {
    return null;
  }

  const areaText = plural(numberOfAreaParts - numberOfPartsToShow, ['площадь', 'площади', 'площадей']);
  const restPartsText = `Ещё ${numberOfAreaParts - numberOfPartsToShow} ${areaText}`;

  return (
    <AreaLink handleClick={handleClick} href={href}>
      {restPartsText}
    </AreaLink>
  );
};
